'use client';
import { useEffect } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';

declare global {
  interface Window {
    hbspt: {
      forms: {
        create: (options: {
          portalId: string;
          formId: string;
          region: string;
          target?: string;
        }) => void;
      };
    };
  }
}

const features = [
  {
    title: 'Targeted Outreach:',
    desc: 'Links from relevant, high-traffic sites in your specific niche.',
  },
  {
    title: 'Data-Driven Strategy:',
    desc: 'We analyze your competitors to find the gaps they missed.',
  },
  {
    title: 'White-Hat Only:',
    desc: '100% manual outreach—no PBNs, no spam, just real relationships.',
  },
  {
    title: 'Proven Results:',
    desc: 'Trusted by SEO managers to deliver links that actually move the needle.',
  },
];

const ContactPage = () => {
  useEffect(() => {
    const loadHubSpot = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '43968755',
          formId: 'a637a7b8-482f-4827-9b1a-84e987aab551',
          region: 'na1',
          target: '#hubspot-form-container',
        });
      }
    };

    if (window.hbspt) {
      loadHubSpot();
      return;
    }

    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    script.onload = loadHubSpot;
    document.body.appendChild(script);

    return () => {
      const container = document.getElementById('hubspot-form-container');
      if (container) container.innerHTML = '';
    };
  }, []);

  return (
    <div data-component-id="src/app/contact/ContactPage.tsx:72:4" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="72" data-component-end-line="227" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-white%22%7D" className="min-h-screen bg-white">
      <Header data-component-id="src/app/contact/ContactPage.tsx:73:6" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="73" data-component-end-line="73" data-component-file="ContactPage.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" />

    <main data-component-id="src/app/contact/ContactPage.tsx:75:4" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="75" data-component-end-line="222" data-component-file="ContactPage.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22w-full%20overflow-hidden%22%7D" className="w-full overflow-hidden">
  {/* FULL WIDTH SPLIT BACKGROUND */}
  <div data-component-id="src/app/contact/ContactPage.tsx:77:2" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="77" data-component-end-line="221" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20w-full%22%7D" className="relative w-full">
    
    {/* Background split */}
    <div data-component-id="src/app/contact/ContactPage.tsx:80:4" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="80" data-component-end-line="110" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20hidden%20lg%3Aflex%22%7D" className="absolute inset-0 hidden lg:flex">
      <div data-component-id="src/app/contact/ContactPage.tsx:81:6" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="81" data-component-end-line="97" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B45%25%5D%20relative%20overflow-hidden%22%7D"
        className="w-[45%] relative overflow-hidden"
        style={{
          background:
            'linear-gradient(135deg, #8D6108 0%, #AE8022 45%, #BB8C2B 100%)',
        }}
      >
        {/* Gold dots */}
        <div data-component-id="src/app/contact/ContactPage.tsx:89:8" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="89" data-component-end-line="96" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20opacity-15%22%7D"
          className="absolute inset-0 opacity-15"
          style={{
            backgroundImage:
              'radial-gradient(circle, rgba(0,0,0,0.45) 1px, transparent 1px)',
            backgroundSize: '18px 18px',
          }}
        />
      </div>

      <div data-component-id="src/app/contact/ContactPage.tsx:99:6" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="99" data-component-end-line="109" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B55%25%5D%20bg-%5B%23111111%5D%20relative%20overflow-hidden%22%7D" className="w-[55%] bg-[#111111] relative overflow-hidden">
        {/* Dark dots */}
        <div data-component-id="src/app/contact/ContactPage.tsx:101:8" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="101" data-component-end-line="108" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20opacity-10%22%7D"
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage:
              'radial-gradient(circle, rgba(196,151,10,0.8) 1px, transparent 1px)',
            backgroundSize: '20px 20px',
          }}
        />
      </div>
    </div>

    {/* CONTENT CONTAINER */}
    <div data-component-id="src/app/contact/ContactPage.tsx:113:4" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="113" data-component-end-line="220" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20z-10%20w-full%20max-w-%5B1246px%5D%20mx-auto%22%7D" className="relative z-10 w-full max-w-[1246px] mx-auto">
      <div data-component-id="src/app/contact/ContactPage.tsx:114:6" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="114" data-component-end-line="219" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20lg%3Aflex-row%22%7D" className="flex flex-col lg:flex-row">

        {/* ── LEFT SECTION ── */}
        <div data-component-id="src/app/contact/ContactPage.tsx:117:8" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="117" data-component-end-line="162" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%20w-full%20lg%3Aw-%5B45%25%5D%20flex%20flex-col%20%20px-5%20sm%3Apx-8%20lg%3Apx-14%20%20%20py-16%20lg%3Apy-24%20%20%20relative%20overflow-hidden%20%20bg-gradient-to-br%20%20%20from-%5B%238D6108%5D%20%20%20via-%5B%23AE8022%5D%20to-%5B%23BB8C2B%5D%20%20lg%3Abg-none%20%22%7D" className=" w-full lg:w-[45%] flex flex-col  px-5 sm:px-8 lg:px-14   py-16 lg:py-24   relative overflow-hidden  bg-gradient-to-br   from-[#8D6108]   via-[#AE8022] to-[#BB8C2B]  lg:bg-none "
>
          {/* Mobile dots */}
          <div data-component-id="src/app/contact/ContactPage.tsx:120:10" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="120" data-component-end-line="127" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20opacity-15%20lg%3Ahidden%22%7D"
            className="absolute inset-0 opacity-15 lg:hidden"
            style={{
              backgroundImage:
                'radial-gradient(circle, rgba(0,0,0,0.45) 1px, transparent 1px)',
              backgroundSize: '18px 18px',
            }}
          />

          <div data-component-id="src/app/contact/ContactPage.tsx:129:10" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="129" data-component-end-line="161" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20z-10%20flex%20flex-col%20gap-8%20max-w-%5B420px%5D%22%7D" className="relative z-10 flex flex-col gap-8 max-w-[420px]">
            {/* Headline */}
            <h1 data-component-id="src/app/contact/ContactPage.tsx:131:12" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="131" data-component-end-line="133" data-component-file="ContactPage.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22text-%5B32px%5D%20sm%3Atext-%5B40px%5D%20lg%3Atext-%5B40px%5D%20font-bold%20leading-%5B1.15%5D%20text-white%22%2C%22textContent%22%3A%22Let's%20Scale%20Your%20Organic%20Rankings%20with%20Elite%20Backlinks.%22%7D" className="text-[32px] sm:text-[40px] lg:text-[40px] font-bold leading-[1.15] text-white">
              Let&apos;s Scale Your Organic Rankings with Elite Backlinks.
            </h1>

            {/* Sub-text */}
            <p data-component-id="src/app/contact/ContactPage.tsx:136:12" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="136" data-component-end-line="140" data-component-file="ContactPage.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B15px%5D%20sm%3Atext-%5B17px%5D%20text-white%2F90%20leading-relaxed%22%2C%22textContent%22%3A%22Fill%20out%20the%20form%20below%20to%20share%20your%20SEO%20goals.%20Our%20team%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20will%20analyze%20your%20site%20and%20provide%20a%20custom%20link-building%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20strategy%20to%20dominate%20your%20niche.%22%7D" className="text-[15px] sm:text-[17px] text-white/90 leading-relaxed">
              Fill out the form below to share your SEO goals. Our team
              will analyze your site and provide a custom link-building
              strategy to dominate your niche.
            </p>

            {/* Feature list */}
            <ul data-component-id="src/app/contact/ContactPage.tsx:143:12" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="143" data-component-end-line="160" data-component-file="ContactPage.tsx" data-component-name="ul" data-component-content="%7B%22elementName%22%3A%22ul%22%2C%22className%22%3A%22flex%20flex-col%20gap-5%22%7D" className="flex flex-col gap-5">
              {features.map((item) => (
                <li data-component-id="src/app/contact/ContactPage.tsx:145:16" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="145" data-component-end-line="158" data-component-file="ContactPage.tsx" data-component-name="li" data-component-content="%7B%22elementName%22%3A%22li%22%2C%22className%22%3A%22flex%20items-start%20gap-4%22%7D" key={item.title} className="flex items-start gap-4">
                  <img data-component-id="src/app/contact/ContactPage.tsx:146:18" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="146" data-component-end-line="150" data-component-file="ContactPage.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%2Fimages%2Fcontact-arrow.webp%22%2C%22alt%22%3A%22arrow%22%2C%22className%22%3A%22w-10%20h-10%20object-contain%20flex-shrink-0%20mt-1%22%7D"
                    src="/images/contact-arrow.webp"
                    alt="arrow"
                    className="w-10 h-10 object-contain flex-shrink-0 mt-1"
                  />

                  <p data-component-id="src/app/contact/ContactPage.tsx:152:18" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="152" data-component-end-line="157" data-component-file="ContactPage.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B14px%5D%20sm%3Atext-%5B16px%5D%20text-white%2F90%20leading-relaxed%22%7D" className="text-[14px] sm:text-[16px] text-white/90 leading-relaxed">
                    <span data-component-id="src/app/contact/ContactPage.tsx:153:20" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="153" data-component-end-line="155" data-component-file="ContactPage.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-semibold%20text-white%22%7D" className="font-semibold text-white">
                      {item.title}
                    </span>{' '}
                    {item.desc}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* ── RIGHT SECTION ── */}
        <div data-component-id="src/app/contact/ContactPage.tsx:165:8" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="165" data-component-end-line="217" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20w-full%20lg%3Aw-%5B55%25%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20flex%20flex-col%20%5Cn%20%20%20%20%20%20%20%20%20%20%20%20px-5%20sm%3Apx-8%20lg%3Apx-14%5Cn%20%20%20%20%20%20%20%20%20%20%20%20py-16%20lg%3Apy-24%5Cn%20%20%20%20%20%20%20%20%20%20%20%20bg-%5B%23111111%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20relative%20overflow-hidden%5Cn%20%20%20%20%20%20%20%20%20%20%22%7D"
          className="
            w-full lg:w-[55%]
            flex flex-col 
            px-5 sm:px-8 lg:px-14
            py-16 lg:py-24
            bg-[#111111]
            relative overflow-hidden
          "
        >
          {/* Mobile dots */}
          <div data-component-id="src/app/contact/ContactPage.tsx:176:10" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="176" data-component-end-line="183" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20opacity-10%20lg%3Ahidden%22%7D"
            className="absolute inset-0 opacity-10 lg:hidden"
            style={{
              backgroundImage:
                'radial-gradient(circle, rgba(196,151,10,0.8) 1px, transparent 1px)',
              backgroundSize: '20px 20px',
            }}
          />

          <div data-component-id="src/app/contact/ContactPage.tsx:185:10" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="185" data-component-end-line="216" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20z-10%20w-full%20max-w-%5B580px%5D%22%7D" className="relative z-10 w-full max-w-[580px]">
            <h2 data-component-id="src/app/contact/ContactPage.tsx:186:12" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="186" data-component-end-line="188" data-component-file="ContactPage.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B30px%5D%20sm%3Atext-%5B40px%5D%20font-bold%20text-white%20mb-8%22%2C%22textContent%22%3A%22Contact%20us%20Now!%22%7D" className="text-[30px] sm:text-[40px] font-bold text-white mb-8">
              Contact us Now!
            </h2>

            {/* HubSpot Script */}
            <script data-component-id="src/app/contact/ContactPage.tsx:191:12" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="191" data-component-end-line="195" data-component-file="ContactPage.tsx" data-component-name="script" data-component-content="%7B%22elementName%22%3A%22script%22%2C%22type%22%3A%22text%2Fjavascript%22%2C%22src%22%3A%22%2F%2Fjs.hsforms.net%2Fforms%2Fembed%2Fv2.js%22%7D"
              charset="utf-8"
              type="text/javascript"
              src="//js.hsforms.net/forms/embed/v2.js"
            ></script>

            <div data-component-id="src/app/contact/ContactPage.tsx:197:12" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="197" data-component-end-line="210" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              dangerouslySetInnerHTML={{
                __html: `
                  <script>
                    hbspt.forms.create({
                      portalId: "43968755",
                      formId: "a637a7b8-482f-4827-9b1a-84e987aab551",
                      region: "na1",
                      target: "#hubspot-form-container"
                    });
                  </script>
                `,
              }}
            />

            <div data-component-id="src/app/contact/ContactPage.tsx:212:12" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="212" data-component-end-line="215" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22hubspot-form-container%22%2C%22className%22%3A%22hubspot-contact-form%22%7D"
              id="hubspot-form-container"
              className="hubspot-contact-form"
            />
          </div>
        </div>

      </div>
    </div>
  </div>
</main>

   

      <Footer data-component-id="src/app/contact/ContactPage.tsx:226:6" data-component-path="src/app/contact/ContactPage.tsx" data-component-line="226" data-component-end-line="226" data-component-file="ContactPage.tsx" data-component-name="Footer" data-component-content="%7B%22elementName%22%3A%22Footer%22%7D" />
    </div>
  );
};

export default ContactPage;